module.exports = __webpack_public_path__ + "static/images/logotype.c789d5f6ce43534827d514b5f7d14353.svg";